import { render, staticRenderFns } from "./ProductMiniChart.vue?vue&type=template&id=d2be3206&"
import script from "./ProductMiniChart.vue?vue&type=script&lang=js&"
export * from "./ProductMiniChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports